module.exports = __webpack_public_path__ + "static/img/11.654c952.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/sp/11.png
// module id = uXxF
// module chunks = 0